export default __webpack_public_path__ + "static/media/project2.2e999688.png";